import {
  UPCOMING_BOOKINGS_LIST_START,
  UPCOMING_BOOKINGS_LIST_SUCCESS,
  UPCOMING_BOOKINGS_LIST_ERROR,
  ONGOING_BOOKINGS_LIST_START,
  ONGOING_BOOKINGS_LIST_SUCCESS,
  ONGOING_BOOKINGS_LIST_ERROR,
  COMPLETED_BOOKINGS_LIST_START,
  COMPLETED_BOOKINGS_LIST_SUCCESS,
  COMPLETED_BOOKINGS_LIST_ERROR,
  CANCELLED_BOOKINGS_LIST_START,
  CANCELLED_BOOKINGS_LIST_SUCCESS,
  CANCELLED_BOOKINGS_LIST_ERROR,
  ADMIN_BOOKING_LIST_START,
  ADMIN_BOOKING_LIST_ERROR,
} from "../Constants/BookingListConstants";
const initialState = {
  loading: false,
  upcomingList: [],
  ongoingList: [],
  completedList: [],
  cancelledList: [],
  // upcomingList: [
  //     {
  //         "bookingList": [
  //             {
  //                 "trip_start_date": "2021-12-20",
  //                 "trip_end_date": "2021-11-30",
  //                 "trip_name": "Leh trip- Test",
  //                 "trip_increment": "IN1234",
  //                 "operator_name": "Test Company",
  //                 "operator_mobile": "1234567898",
  //                 "booked_seat": "1",
  //                 "trip_start_point": "Manali",
  //                 "trip_end_point": "Leh",
  //                 "booking_series_id": "BT0002",
  //                 "booking_on": "2021-04-28 09:41:15",
  //                 "booked_by_name": "abc def",
  //                 "booked_by_email": "test@customer.com",
  //                 "payment": ""
  //             },
  //             {
  //                 "trip_start_date": "2021-11-29",
  //                 "trip_end_date": "2021-11-30",
  //                 "trip_name": "Leh trip- Test",
  //                 "trip_increment": "IN1234",
  //                 "operator_name": "Test Company",
  //                 "operator_mobile": "1234567898",
  //                 "booked_seat": "2",
  //                 "trip_start_point": "Ahmedabad",
  //                 "trip_end_point": "Delhi",
  //                 "booking_series_id": "BT0001",
  //                 "booking_on": "2021-04-28 10:27:24",
  //                 "booked_by_name": "abc def",
  //                 "booked_by_email": "test@customer.com",
  //                 "payment": ""
  //             }
  //         ],
  //         "points": {
  //             "start_point": {
  //                 "0": "Ahmedabad",
  //                 "2": "Manali"
  //             },
  //             "end_point": {
  //                 "0": "Delhi",
  //                 "2": "Leh"
  //             }
  //         },
  //         "count": 2,
  //         "limit": "10",
  //         "page": "1"
  //     }
  // ],
  // ongoingList: [
  //     {
  //         "bookingList": [
  //             {
  //                 "trip_start_date": "2021-12-20",
  //                 "trip_end_date": "2021-11-30",
  //                 "trip_name": "Leh trip- Test",
  //                 "trip_increment": "IN1234",
  //                 "operator_name": "Test Company",
  //                 "operator_mobile": "1234567898",
  //                 "booked_seat": "1",
  //                 "trip_start_point": "Manali",
  //                 "trip_end_point": "Leh",
  //                 "booking_series_id": "BT0002",
  //                 "booking_on": "2021-04-28 09:41:15",
  //                 "booked_by_name": "abc def",
  //                 "booked_by_email": "test@customer.com",
  //                 "payment": ""
  //             },
  //             {
  //                 "trip_start_date": "2021-11-29",
  //                 "trip_end_date": "2021-11-30",
  //                 "trip_name": "Leh trip- Test",
  //                 "trip_increment": "IN1234",
  //                 "operator_name": "Test Company",
  //                 "operator_mobile": "1234567898",
  //                 "booked_seat": "2",
  //                 "trip_start_point": "Ahmedabad",
  //                 "trip_end_point": "Delhi",
  //                 "booking_series_id": "BT0001",
  //                 "booking_on": "2021-04-28 10:27:24",
  //                 "booked_by_name": "abc def",
  //                 "booked_by_email": "test@customer.com",
  //                 "payment": ""
  //             }
  //         ],
  //         "points": {
  //             "start_point": {
  //                 "0": "Ahmedabad",
  //                 "2": "Manali"
  //             },
  //             "end_point": {
  //                 "0": "Delhi",
  //                 "2": "Leh"
  //             }
  //         },
  //         "count": 2,
  //         "limit": "10",
  //         "page": "1"
  //     }
  // ],
  // completedList: [
  //     {
  //         "bookingList": [
  //             {
  //                 "trip_start_date": "2021-12-20",
  //                 "trip_end_date": "2021-11-30",
  //                 "trip_name": "Leh trip- Test",
  //                 "trip_increment": "IN1234",
  //                 "operator_name": "Test Company",
  //                 "operator_mobile": "1234567898",
  //                 "booked_seat": "1",
  //                 "trip_start_point": "Manali",
  //                 "trip_end_point": "Leh",
  //                 "booking_series_id": "BT0002",
  //                 "booking_on": "2021-04-28 09:41:15",
  //                 "booked_by_name": "abc def",
  //                 "booked_by_email": "test@customer.com",
  //                 "payment": ""
  //             },
  //             {
  //                 "trip_start_date": "2021-11-29",
  //                 "trip_end_date": "2021-11-30",
  //                 "trip_name": "Leh trip- Test",
  //                 "trip_increment": "IN1234",
  //                 "operator_name": "Test Company",
  //                 "operator_mobile": "1234567898",
  //                 "booked_seat": "2",
  //                 "trip_start_point": "Ahmedabad",
  //                 "trip_end_point": "Delhi",
  //                 "booking_series_id": "BT0001",
  //                 "booking_on": "2021-04-28 10:27:24",
  //                 "booked_by_name": "abc def",
  //                 "booked_by_email": "test@customer.com",
  //                 "payment": ""
  //             }
  //         ],
  //         "points": {
  //             "start_point": {
  //                 "0": "Ahmedabad",
  //                 "2": "Manali"
  //             },
  //             "end_point": {
  //                 "0": "Delhi",
  //                 "2": "Leh"
  //             }
  //         },
  //         "count": 2,
  //         "limit": "10",
  //         "page": "1"
  //     }
  // ],
  // cancelledList: [
  //     {
  //         "bookingList": [
  //             {
  //                 "trip_start_date": "2021-12-20",
  //                 "trip_end_date": "2021-11-30",
  //                 "trip_name": "Leh trip- Test",
  //                 "trip_increment": "IN1234",
  //                 "operator_name": "Test Company",
  //                 "operator_mobile": "1234567898",
  //                 "booked_seat": "1",
  //                 "trip_start_point": "Manali",
  //                 "trip_end_point": "Leh",
  //                 "booking_series_id": "BT0002",
  //                 "booking_on": "2021-04-28 09:41:15",
  //                 "booked_by_name": "abc def",
  //                 "booked_by_email": "test@customer.com",
  //                 "payment": ""
  //             },
  //             {
  //                 "trip_start_date": "2021-11-29",
  //                 "trip_end_date": "2021-11-30",
  //                 "trip_name": "Leh trip- Test",
  //                 "trip_increment": "IN1234",
  //                 "operator_name": "Test Company",
  //                 "operator_mobile": "1234567898",
  //                 "booked_seat": "2",
  //                 "trip_start_point": "Ahmedabad",
  //                 "trip_end_point": "Delhi",
  //                 "booking_series_id": "BT0001",
  //                 "booking_on": "2021-04-28 10:27:24",
  //                 "booked_by_name": "abc def",
  //                 "booked_by_email": "test@customer.com",
  //                 "payment": ""
  //             }
  //         ],
  //         "points": {
  //             "start_point": {
  //                 "0": "Ahmedabad",
  //                 "2": "Manali"
  //             },
  //             "end_point": {
  //                 "0": "Delhi",
  //                 "2": "Leh"
  //             }
  //         },
  //         "count": 2,
  //         "limit": "10",
  //         "page": "1"
  //     }
  // ]
};
export default function BookingListReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case ADMIN_BOOKING_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case UPCOMING_BOOKINGS_LIST_START:
      return {
        ...state,
        upcomingList: [],
        loading: true,
      };
    case UPCOMING_BOOKINGS_LIST_SUCCESS:
      return {
        ...state,
        upcomingList: action.payload,
        loading: false,
      };
    case UPCOMING_BOOKINGS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case ONGOING_BOOKINGS_LIST_START:
      return {
        ...state,
        ongoingList: [],
        loading: true,
      };
    case ONGOING_BOOKINGS_LIST_SUCCESS:
      return {
        ...state,
        ongoingList: action.payload,
        loading: false,
      };
    case ONGOING_BOOKINGS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case COMPLETED_BOOKINGS_LIST_START:
      return {
        ...state,
        completedList: [],
        loading: true,
      };
    case COMPLETED_BOOKINGS_LIST_SUCCESS:
      return {
        ...state,
        completedList: action.payload,
        loading: false,
      };
    case COMPLETED_BOOKINGS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case CANCELLED_BOOKINGS_LIST_START:
      return {
        ...state,
        cancelledList: [],
        loading: true,
      };
    case CANCELLED_BOOKINGS_LIST_SUCCESS:
      return {
        ...state,
        cancelledList: action.payload,
        loading: false,
      };
    case CANCELLED_BOOKINGS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case ADMIN_BOOKING_LIST_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}
